import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorkCellTask = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_113_10795)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_113_10795",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_113_10795)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M8.99998 20.1191C7.63881 20.1191 6.48189 19.6427 5.52923 18.6898C4.57639 17.7372 4.09998 16.5803 4.09998 15.2191V9.21909C4.09998 7.85793 4.57639 6.70101 5.52923 5.74834C6.48189 4.79551 7.63881 4.31909 8.99998 4.31909H15C16.3611 4.31909 17.5181 4.79551 18.4707 5.74834C19.4236 6.70101 19.9 7.85793 19.9 9.21909V15.2191C19.9 16.5803 19.4236 17.7372 18.4707 18.6898C17.5181 19.6427 16.3611 20.1191 15 20.1191H8.99998ZM10.725 15.0478L15.4787 10.3191L14.55 9.39034L10.725 13.1903L9.02498 11.5153L8.12123 12.4441L10.725 15.0478ZM8.99998 18.8191H15C16 18.8191 16.85 18.4691 17.55 17.7691C18.25 17.0691 18.6 16.2191 18.6 15.2191V9.21909C18.6 8.21909 18.25 7.36909 17.55 6.66909C16.85 5.96909 16 5.61909 15 5.61909H8.99998C7.99998 5.61909 7.14998 5.96909 6.44998 6.66909C5.74998 7.36909 5.39998 8.21909 5.39998 9.21909V15.2191C5.39998 16.2191 5.74998 17.0691 6.44998 17.7691C7.14998 18.4691 7.99998 18.8191 8.99998 18.8191Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_113_10795",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgWorkCellTask;
